import { render, staticRenderFns } from "./DisqualificationDestoryApplyTable.vue?vue&type=template&id=31075d84&scoped=true"
import script from "./DisqualificationDestoryApplyTable.vue?vue&type=script&lang=js"
export * from "./DisqualificationDestoryApplyTable.vue?vue&type=script&lang=js"
import style0 from "./DisqualificationDestoryApplyTable.vue?vue&type=style&index=0&id=31075d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31075d84",
  null
  
)

export default component.exports